import { InjectionToken } from '@angular/core';

export interface GoogleTagManagerConfig {
  id: string;
}

export const GOOGLE_TAG_MANAGER_CONFIG = new InjectionToken<GoogleTagManagerConfig>('GoogleTagManagerConfig');
